import baseAPI from '@/api/base';
import {
  EditKnowledgeBaseCategory,
  GetKnowledgeBaseCategory,
  RegisterKnowledgeBaseCategory,
} from '@/dtos/knowledge_base_category.dto';
import {
  DELETE_KNOWLEDGE_BASE_CATEGORY_URL,
  EDIT_KNOWLEDGE_BASE_CATEGORY_URL,
  GET_KNOWLEDGE_BASE_CATEGORY_URL,
  REGISTER_KNOWLEDGE_BASE_CATEGORY_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class KnowledgeBaseCategory {
  static getKnowledgeBaseCategories = async (
    params: GetKnowledgeBaseCategory
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_KNOWLEDGE_BASE_CATEGORY_URL, {
      params,
    });
    return response;
  };

  static registerKnowledgeBaseCategory = async (
    payload: RegisterKnowledgeBaseCategory
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_KNOWLEDGE_BASE_CATEGORY_URL, {
      ...payload,
    });
    return response;
  };

  static editKnowledgeBaseCategory = async (
    payload: EditKnowledgeBaseCategory
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_KNOWLEDGE_BASE_CATEGORY_URL, {
      ...payload,
    });
    return response;
  };

  static deleteKnowledgeBaseCategory = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_KNOWLEDGE_BASE_CATEGORY_URL}/${id}`
    );
    return response;
  };
}

export default KnowledgeBaseCategory;
